import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/translation.json";
import tr from "./locales/tr/translation.json";
import ur from "./locales/ur/translation.json";
import fr from "./locales/fr/translation.json";
import ru from "./locales/ru/translation.json";
import pt from "./locales/pt/translation.json";
import es from "./locales/es/translation.json";
import ar from "./locales/ar/translation.json";
import ps from "./locales/ps/translation.json";
import prs from "./locales/prs/translation.json";
import fa from "./locales/fa/translation.json";
import zh from "./locales/zh/translation.json";
import ja from "./locales/ja/translation.json";
import ko from "./locales/ko/translation.json";
import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY } from "./constants/languages";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      ur: { translation: ur },
      fr: { translation: fr },
      ru: { translation: ru },
      pt: { translation: pt },
      es: { translation: es },
      ar: { translation: ar },
      ps: { translation: ps },
      prs: { translation: prs },
      fa: { translation: fa },
      zh: { translation: zh },
      ja: { translation: ja },
      ko: { translation: ko },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      // Only look up a previously remembered explicit choice at init time.
      // During normal use the active language is driven by the URL (see
      // LanguageWrapper); first-visit browser-language detection is handled
      // separately in LanguageRedirect.
      order: ["localStorage"],
      // Deliberately NOT caching here. LanguageWrapper calls changeLanguage()
      // on every mount just to sync state to the URL — including transient
      // calls from an old route branch's instance mid-transition, before the
      // new one settles. If the detector auto-writes every changeLanguage()
      // call to this same key, those incidental syncs get mistaken for an
      // explicit user choice and corrupt it. Only LanguageSwitcher's
      // deliberate localStorage.setItem() (an actual click) should ever
      // write LANGUAGE_STORAGE_KEY.
      caches: [],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
